import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { StyleSheet, View } from 'react-native';

const styles = StyleSheet.create({
  container: {
    paddingTop: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
    paddingBottom: Utils.Token.ToInt(Spacing, 'inline.xxxs'),
  },
  divider: {
    backgroundColor: Color['neutral.lightest'],
    height: 1,
    width: '100%',
  },
});

export const Divider = () => {
  return (
    <View style={styles.container}>
      <View style={styles.divider} />
    </View>
  );
};
